import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import logoLight from '../../assets/logo-light.svg';
import logoDark from '../../assets/images/logo-dark.svg';

// A responsive logo component that supports both light and dark variants
const Logo = ({ variant = 'light', className = '', linkTo = '/', autoDetect = false }) => {
  const [autoVariant, setAutoVariant] = useState(variant);
  const logoRef = useRef(null);
  
  // If autoDetect is true, try to detect background color and adjust variant
  useEffect(() => {
    if (autoDetect && logoRef.current) {
      const detectBackgroundColor = () => {
        const parent = logoRef.current.parentElement;
        if (parent) {
          const bgColor = window.getComputedStyle(parent).backgroundColor;
          // Check if background is dark
          const rgb = bgColor.match(/\d+/g);
          if (rgb && rgb.length >= 3) {
            // Simple check - if average RGB value is less than 128, consider it dark
            const brightness = (parseInt(rgb[0]) + parseInt(rgb[1]) + parseInt(rgb[2])) / 3;
            setAutoVariant(brightness < 128 ? 'dark' : 'light');
          }
        }
      };
      
      detectBackgroundColor();
      // Recheck on window resize
      window.addEventListener('resize', detectBackgroundColor);
      return () => window.removeEventListener('resize', detectBackgroundColor);
    }
  }, [autoDetect]);
  
  // Determine which logo to use based on variant
  const currentVariant = autoDetect ? autoVariant : variant;
  // Select the appropriate logo based on the variant
  const logoSrc = currentVariant === 'dark' ? logoDark : logoLight;
  
  return (
    <Link to={linkTo} className={`flex items-center ${className}`} ref={logoRef}>
      <img 
        src={logoSrc} 
        alt="Company Logo" 
        className="h-8 md:h-9 w-auto" 
      />
    </Link>
  );
};

export default Logo; 